export default {
    methods: {
        getImagePath(imageName) {
            const lang = this.$i18n.locale;
            const folder = lang === 'en' ? 'img-en' : 'img-zh';
            return require(`@/assets/${folder}/${imageName}`);
        }
    }
}
